import { gql } from '@parkchirp/api-client';

export const VALIDATE_VEHICLES_FOR_BULK_UPLOAD = gql`
  query validateVehiclesForBulkUpload(
    $vehicles: [ValidateVehiclesForBulkUploadRequestType]!
  ) {
    validateVehiclesForBulkUpload(vehicles: $vehicles) {
      data {
        rowIndex
        isValid
        suggestions
        make
        model
      }
    }
  }
`;

export const GET_VEHICLES_CSV = gql`
  query getVehiclesCsv {
    getVehiclesCsv {
        url
    }
  }
`;
